import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookie auth (güvenlik sertleştirmesi): JWT'ler artık localStorage'da SAKLANMAZ.
// Oturum, sunucunun set ettiği httpOnly 'access_token'/'refresh_token' cookie'leriyle taşınır
// (axios withCredentials + fetch credentials:'include'). Böylece JS/XSS token'lara erişemez.
// tokenStore yalnızca geriye-uyumluluk için memory-only no-op shim olarak korunur.
const memoryStore = { access: null, refresh: null };

export const tokenStore = {
  getAccess: () => memoryStore.access,
  getRefresh: () => memoryStore.refresh,
  set: () => { /* no-op: token'lar httpOnly cookie'de tutulur */ },
  clear: () => { memoryStore.access = null; memoryStore.refresh = null; },
};

const api = axios.create({ baseURL: API, withCredentials: true });

// Auth artık httpOnly cookie ile taşınır — withCredentials her isteğe cookie'yi ekler,
// bu yüzden Authorization header enjeksiyonuna gerek yok.

let refreshPromise = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;
    const url = original?.url || "";
    const method = (original?.method || "").toUpperCase();

    const isAuthEndpoint =
      url.includes("/auth/refresh") ||
      url.includes("/auth/login") ||
      url.includes("/auth/logout") ||
      url.includes("/auth/me");

    // 401: otomatik refresh dene
    if (status === 401 && original && !original._retried && !isAuthEndpoint) {
      original._retried = true;
      try {
        if (!refreshPromise) {
          // Refresh token httpOnly cookie'den okunur (body gerekmez); yeni cookie'ler sunucu set eder.
          refreshPromise = api.post("/auth/refresh", {})
            .finally(() => { setTimeout(() => { refreshPromise = null; }, 500); });
        }
        await refreshPromise;
        return api(original);
      } catch (_) {
        tokenStore.clear();
        if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent("auth:expired"));
      }
    }

    // Axios ham hata mesajını Türkçeleştir. Response interceptor içinde error.message'ı
    // güncelleyerek her .catch bloğunda daha anlaşılır mesaj çıkar.
    if (status && !error._friendlyMessageApplied) {
      const backendDetail = error?.response?.data?.detail;
      if (typeof backendDetail === "string" && backendDetail.length) {
        error.message = backendDetail;
      } else {
        const isRead = method === "GET";
        const notFoundMsg = isRead
          ? `Kayıt bulunamadı (404 · ${method} ${url}).`
          : "Sunucu geçici olarak erişilemiyor, birkaç saniye sonra tekrar deneyin.";
        const map = {
          400: "İstek geçersiz (400).",
          403: "Bu işlem için yetkiniz yok (403).",
          404: notFoundMsg,
          409: "Bu kayıt zaten var (409).",
          422: "Girilen veriler doğrulanamadı (422).",
          429: "Çok fazla istek gönderildi, biraz bekleyin (429).",
          500: "Sunucu hatası (500). Tekrar deneyin.",
          502: "Sunucuya ulaşılamadı (502).",
          503: "Servis geçici olarak kullanılamıyor (503).",
        };
        error.message = map[status] || `Beklenmedik hata (${status}).`;
      }
      // Debug için 404/500'leri konsola bas
      if (status === 404 || status >= 500) {
        console.error(`[API ${status}] ${method} ${url}`, error?.response?.data);
      }
      error._friendlyMessageApplied = true;
    } else if (!status && !error._friendlyMessageApplied) {
      // Network hatası (response yok)
      error.message = "Sunucuya bağlanılamadı. İnternet bağlantınızı kontrol edin.";
      error._friendlyMessageApplied = true;
    }

    return Promise.reject(error);
  }
);

export default api;
